"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryClientImpl = exports.QueryAllControllersResponse = exports.QueryAllControllersRequest = exports.QueryControllersForConnectionResponse = exports.QueryControllersForConnectionRequest = exports.QueryPendingActionResponse = exports.QueryPendingActionRequest = exports.QueryAllPendingActionNonceResponse = exports.QueryAllPendingActionNonceRequest = exports.QueryAllRelayerResponse = exports.QueryAllRelayerRequest = exports.QueryRelayerResponse = exports.QueryRelayerRequest = exports.QueryCarbonGmpAccountResponse = exports.QueryCarbonGmpAccountRequest = exports.QueryAllExternalTokensResponse = exports.QueryAllExternalTokensRequest = exports.QueryAllConnectionsResponse = exports.QueryAllConnectionsRequest = exports.QueryAllBridgeStatesResponse = exports.QueryAllBridgeStatesRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const params_1 = require("./params");
const pagination_1 = require("../../../cosmos/base/query/v1beta1/pagination");
const bridge_1 = require("./bridge");
exports.protobufPackage = "Switcheo.carbon.bridge";
const baseQueryParamsRequest = {};
exports.QueryParamsRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
};
const baseQueryParamsResponse = {};
exports.QueryParamsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.params !== undefined) {
            params_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = params_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        message.params =
            object.params !== undefined && object.params !== null
                ? params_1.Params.fromJSON(object.params)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined &&
            (obj.params = message.params ? params_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        message.params =
            object.params !== undefined && object.params !== null
                ? params_1.Params.fromPartial(object.params)
                : undefined;
        return message;
    },
};
const baseQueryAllBridgeStatesRequest = {};
exports.QueryAllBridgeStatesRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllBridgeStatesRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllBridgeStatesRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllBridgeStatesRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllBridgeStatesResponse = {};
exports.QueryAllBridgeStatesResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.bridgeStates) {
            bridge_1.BridgeState.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllBridgeStatesResponse);
        message.bridgeStates = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bridgeStates.push(bridge_1.BridgeState.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllBridgeStatesResponse);
        message.bridgeStates = ((_a = object.bridgeStates) !== null && _a !== void 0 ? _a : []).map((e) => bridge_1.BridgeState.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.bridgeStates) {
            obj.bridgeStates = message.bridgeStates.map((e) => e ? bridge_1.BridgeState.toJSON(e) : undefined);
        }
        else {
            obj.bridgeStates = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllBridgeStatesResponse);
        message.bridgeStates = ((_a = object.bridgeStates) !== null && _a !== void 0 ? _a : []).map((e) => bridge_1.BridgeState.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllConnectionsRequest = { bridgeId: long_1.default.UZERO };
exports.QueryAllConnectionsRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.bridgeId.isZero()) {
            writer.uint32(8).uint64(message.bridgeId);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllConnectionsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bridgeId = reader.uint64();
                    break;
                case 2:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllConnectionsRequest);
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromString(object.bridgeId)
                : long_1.default.UZERO;
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.bridgeId !== undefined &&
            (obj.bridgeId = (message.bridgeId || long_1.default.UZERO).toString());
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllConnectionsRequest);
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromValue(object.bridgeId)
                : long_1.default.UZERO;
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllConnectionsResponse = {};
exports.QueryAllConnectionsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.connections) {
            bridge_1.Connection.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllConnectionsResponse);
        message.connections = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connections.push(bridge_1.Connection.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllConnectionsResponse);
        message.connections = ((_a = object.connections) !== null && _a !== void 0 ? _a : []).map((e) => bridge_1.Connection.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.connections) {
            obj.connections = message.connections.map((e) => e ? bridge_1.Connection.toJSON(e) : undefined);
        }
        else {
            obj.connections = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllConnectionsResponse);
        message.connections = ((_a = object.connections) !== null && _a !== void 0 ? _a : []).map((e) => bridge_1.Connection.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllExternalTokensRequest = {
    bridgeId: long_1.default.UZERO,
    chainId: "",
    denom: "",
};
exports.QueryAllExternalTokensRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.bridgeId.isZero()) {
            writer.uint32(8).uint64(message.bridgeId);
        }
        if (message.chainId !== "") {
            writer.uint32(18).string(message.chainId);
        }
        if (message.denom !== "") {
            writer.uint32(26).string(message.denom);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllExternalTokensRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.bridgeId = reader.uint64();
                    break;
                case 2:
                    message.chainId = reader.string();
                    break;
                case 3:
                    message.denom = reader.string();
                    break;
                case 4:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllExternalTokensRequest);
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromString(object.bridgeId)
                : long_1.default.UZERO;
        message.chainId =
            object.chainId !== undefined && object.chainId !== null
                ? String(object.chainId)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.bridgeId !== undefined &&
            (obj.bridgeId = (message.bridgeId || long_1.default.UZERO).toString());
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.denom !== undefined && (obj.denom = message.denom);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b;
        const message = Object.assign({}, baseQueryAllExternalTokensRequest);
        message.bridgeId =
            object.bridgeId !== undefined && object.bridgeId !== null
                ? long_1.default.fromValue(object.bridgeId)
                : long_1.default.UZERO;
        message.chainId = (_a = object.chainId) !== null && _a !== void 0 ? _a : "";
        message.denom = (_b = object.denom) !== null && _b !== void 0 ? _b : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllExternalTokensResponse = {};
exports.QueryAllExternalTokensResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.externalTokens) {
            bridge_1.ExternalTokenMapping.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllExternalTokensResponse);
        message.externalTokens = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.externalTokens.push(bridge_1.ExternalTokenMapping.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllExternalTokensResponse);
        message.externalTokens = ((_a = object.externalTokens) !== null && _a !== void 0 ? _a : []).map((e) => bridge_1.ExternalTokenMapping.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.externalTokens) {
            obj.externalTokens = message.externalTokens.map((e) => e ? bridge_1.ExternalTokenMapping.toJSON(e) : undefined);
        }
        else {
            obj.externalTokens = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllExternalTokensResponse);
        message.externalTokens = ((_a = object.externalTokens) !== null && _a !== void 0 ? _a : []).map((e) => bridge_1.ExternalTokenMapping.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryCarbonGmpAccountRequest = {};
exports.QueryCarbonGmpAccountRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryCarbonGmpAccountRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryCarbonGmpAccountRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryCarbonGmpAccountRequest);
        return message;
    },
};
const baseQueryCarbonGmpAccountResponse = { carbonGmpAccount: "" };
exports.QueryCarbonGmpAccountResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.carbonGmpAccount !== "") {
            writer.uint32(10).string(message.carbonGmpAccount);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryCarbonGmpAccountResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.carbonGmpAccount = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryCarbonGmpAccountResponse);
        message.carbonGmpAccount =
            object.carbonGmpAccount !== undefined && object.carbonGmpAccount !== null
                ? String(object.carbonGmpAccount)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.carbonGmpAccount !== undefined &&
            (obj.carbonGmpAccount = message.carbonGmpAccount);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryCarbonGmpAccountResponse);
        message.carbonGmpAccount = (_a = object.carbonGmpAccount) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryRelayerRequest = { address: "" };
exports.QueryRelayerRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryRelayerRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryRelayerRequest);
        message.address =
            object.address !== undefined && object.address !== null
                ? String(object.address)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryRelayerRequest);
        message.address = (_a = object.address) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryRelayerResponse = { hasRelayer: false };
exports.QueryRelayerResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.hasRelayer === true) {
            writer.uint32(8).bool(message.hasRelayer);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryRelayerResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hasRelayer = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryRelayerResponse);
        message.hasRelayer =
            object.hasRelayer !== undefined && object.hasRelayer !== null
                ? Boolean(object.hasRelayer)
                : false;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.hasRelayer !== undefined && (obj.hasRelayer = message.hasRelayer);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryRelayerResponse);
        message.hasRelayer = (_a = object.hasRelayer) !== null && _a !== void 0 ? _a : false;
        return message;
    },
};
const baseQueryAllRelayerRequest = {};
exports.QueryAllRelayerRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllRelayerRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllRelayerRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllRelayerRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllRelayerResponse = { relayers: "" };
exports.QueryAllRelayerResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.relayers) {
            writer.uint32(10).string(v);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllRelayerResponse);
        message.relayers = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.relayers.push(reader.string());
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllRelayerResponse);
        message.relayers = ((_a = object.relayers) !== null && _a !== void 0 ? _a : []).map((e) => String(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.relayers) {
            obj.relayers = message.relayers.map((e) => e);
        }
        else {
            obj.relayers = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllRelayerResponse);
        message.relayers = ((_a = object.relayers) !== null && _a !== void 0 ? _a : []).map((e) => e);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllPendingActionNonceRequest = {};
exports.QueryAllPendingActionNonceRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllPendingActionNonceRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllPendingActionNonceRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllPendingActionNonceRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllPendingActionNonceResponse = {
    pendingActionNonces: long_1.default.UZERO,
};
exports.QueryAllPendingActionNonceResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.pendingActionNonces) {
            writer.uint64(v);
        }
        writer.ldelim();
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllPendingActionNonceResponse);
        message.pendingActionNonces = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.pendingActionNonces.push(reader.uint64());
                        }
                    }
                    else {
                        message.pendingActionNonces.push(reader.uint64());
                    }
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllPendingActionNonceResponse);
        message.pendingActionNonces = ((_a = object.pendingActionNonces) !== null && _a !== void 0 ? _a : []).map((e) => long_1.default.fromString(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.pendingActionNonces) {
            obj.pendingActionNonces = message.pendingActionNonces.map((e) => (e || long_1.default.UZERO).toString());
        }
        else {
            obj.pendingActionNonces = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllPendingActionNonceResponse);
        message.pendingActionNonces = ((_a = object.pendingActionNonces) !== null && _a !== void 0 ? _a : []).map((e) => long_1.default.fromValue(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryPendingActionRequest = { nonce: long_1.default.UZERO };
exports.QueryPendingActionRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (!message.nonce.isZero()) {
            writer.uint32(8).uint64(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryPendingActionRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nonce = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryPendingActionRequest);
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromString(object.nonce)
                : long_1.default.UZERO;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.nonce !== undefined &&
            (obj.nonce = (message.nonce || long_1.default.UZERO).toString());
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryPendingActionRequest);
        message.nonce =
            object.nonce !== undefined && object.nonce !== null
                ? long_1.default.fromValue(object.nonce)
                : long_1.default.UZERO;
        return message;
    },
};
const baseQueryPendingActionResponse = { action: "" };
exports.QueryPendingActionResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.action !== "") {
            writer.uint32(10).string(message.action);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryPendingActionResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.action = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryPendingActionResponse);
        message.action =
            object.action !== undefined && object.action !== null
                ? String(object.action)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.action !== undefined && (obj.action = message.action);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryPendingActionResponse);
        message.action = (_a = object.action) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryControllersForConnectionRequest = { connectionId: "" };
exports.QueryControllersForConnectionRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.connectionId !== "") {
            writer.uint32(10).string(message.connectionId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryControllersForConnectionRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.connectionId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryControllersForConnectionRequest);
        message.connectionId =
            object.connectionId !== undefined && object.connectionId !== null
                ? String(object.connectionId)
                : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.connectionId !== undefined &&
            (obj.connectionId = message.connectionId);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryControllersForConnectionRequest);
        message.connectionId = (_a = object.connectionId) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryControllersForConnectionResponse = {};
exports.QueryControllersForConnectionResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.controllers !== undefined) {
            bridge_1.ControllerContracts.encode(message.controllers, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryControllersForConnectionResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.controllers = bridge_1.ControllerContracts.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryControllersForConnectionResponse);
        message.controllers =
            object.controllers !== undefined && object.controllers !== null
                ? bridge_1.ControllerContracts.fromJSON(object.controllers)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.controllers !== undefined &&
            (obj.controllers = message.controllers
                ? bridge_1.ControllerContracts.toJSON(message.controllers)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryControllersForConnectionResponse);
        message.controllers =
            object.controllers !== undefined && object.controllers !== null
                ? bridge_1.ControllerContracts.fromPartial(object.controllers)
                : undefined;
        return message;
    },
};
const baseQueryAllControllersRequest = {};
exports.QueryAllControllersRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllControllersRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllControllersRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryAllControllersRequest);
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllControllersResponse = {};
exports.QueryAllControllersResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.controllers) {
            bridge_1.ControllerContracts.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllControllersResponse);
        message.controllers = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.controllers.push(bridge_1.ControllerContracts.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllControllersResponse);
        message.controllers = ((_a = object.controllers) !== null && _a !== void 0 ? _a : []).map((e) => bridge_1.ControllerContracts.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.controllers) {
            obj.controllers = message.controllers.map((e) => e ? bridge_1.ControllerContracts.toJSON(e) : undefined);
        }
        else {
            obj.controllers = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllControllersResponse);
        message.controllers = ((_a = object.controllers) !== null && _a !== void 0 ? _a : []).map((e) => bridge_1.ControllerContracts.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.BridgeStateAll = this.BridgeStateAll.bind(this);
        this.ConnectionAll = this.ConnectionAll.bind(this);
        this.ExternalTokenAll = this.ExternalTokenAll.bind(this);
        this.CarbonGmpAccount = this.CarbonGmpAccount.bind(this);
        this.Relayer = this.Relayer.bind(this);
        this.RelayerAll = this.RelayerAll.bind(this);
        this.PendingActionNonceAll = this.PendingActionNonceAll.bind(this);
        this.PendingActionForNonce = this.PendingActionForNonce.bind(this);
        this.ControllersForConnection = this.ControllersForConnection.bind(this);
        this.ControllersAll = this.ControllersAll.bind(this);
    }
    Params(request) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
    BridgeStateAll(request) {
        const data = exports.QueryAllBridgeStatesRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Query", "BridgeStateAll", data);
        return promise.then((data) => exports.QueryAllBridgeStatesResponse.decode(new minimal_1.default.Reader(data)));
    }
    ConnectionAll(request) {
        const data = exports.QueryAllConnectionsRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Query", "ConnectionAll", data);
        return promise.then((data) => exports.QueryAllConnectionsResponse.decode(new minimal_1.default.Reader(data)));
    }
    ExternalTokenAll(request) {
        const data = exports.QueryAllExternalTokensRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Query", "ExternalTokenAll", data);
        return promise.then((data) => exports.QueryAllExternalTokensResponse.decode(new minimal_1.default.Reader(data)));
    }
    CarbonGmpAccount(request) {
        const data = exports.QueryCarbonGmpAccountRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Query", "CarbonGmpAccount", data);
        return promise.then((data) => exports.QueryCarbonGmpAccountResponse.decode(new minimal_1.default.Reader(data)));
    }
    Relayer(request) {
        const data = exports.QueryRelayerRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Query", "Relayer", data);
        return promise.then((data) => exports.QueryRelayerResponse.decode(new minimal_1.default.Reader(data)));
    }
    RelayerAll(request) {
        const data = exports.QueryAllRelayerRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Query", "RelayerAll", data);
        return promise.then((data) => exports.QueryAllRelayerResponse.decode(new minimal_1.default.Reader(data)));
    }
    PendingActionNonceAll(request) {
        const data = exports.QueryAllPendingActionNonceRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Query", "PendingActionNonceAll", data);
        return promise.then((data) => exports.QueryAllPendingActionNonceResponse.decode(new minimal_1.default.Reader(data)));
    }
    PendingActionForNonce(request) {
        const data = exports.QueryPendingActionRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Query", "PendingActionForNonce", data);
        return promise.then((data) => exports.QueryPendingActionResponse.decode(new minimal_1.default.Reader(data)));
    }
    ControllersForConnection(request) {
        const data = exports.QueryControllersForConnectionRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Query", "ControllersForConnection", data);
        return promise.then((data) => exports.QueryControllersForConnectionResponse.decode(new minimal_1.default.Reader(data)));
    }
    ControllersAll(request) {
        const data = exports.QueryAllControllersRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.bridge.Query", "ControllersAll", data);
        return promise.then((data) => exports.QueryAllControllersResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
